import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  dropdownContainer: {
    position: "absolute",
    top: "40px",
    left: 0,
    width: "360px",
    backgroundColor: theme?.palette?.primaryBG?.[350] || theme?.palette?.primaryBG?.[400],
    borderRadius: "12px",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.5)",
    zIndex: 1000,
    overflowY: "auto",
    overflowX: "hidden",
    WebkitOverflowScrolling: "touch",
    overscrollBehavior: "contain",
    touchAction: "pan-y",
    pointerEvents: "auto",
    maxHeight: "340px",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": { display: "none" },
    border: `1px solid ${theme?.palette?.secondaryBG?.main || "rgba(255, 255, 255, 0.1)"}`,

    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      top: "60px",
      left: "50%",
      transform: "translateX(-50%)",
      width: "94%",
      maxWidth: "380px",
      zIndex: 1300,
      maxHeight: "min(340px, calc(100dvh - 80px))",
      overflowY: "scroll",
      overflowX: "hidden",
      WebkitOverflowScrolling: "touch",
      touchAction: "pan-y",
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": { display: "none" },
    },

    [theme.breakpoints.between("sm", "md")]: {
      position: "fixed",
      top: "60px",
      left: "50%",
      transform: "translateX(-50%)",
      width: "94%",
      maxWidth: "380px",
      zIndex: 1300,
      maxHeight: "min(340px, calc(100dvh - 80px))",
      overflowY: "scroll",
      overflowX: "hidden",
      WebkitOverflowScrolling: "touch",
      touchAction: "pan-y",
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": { display: "none" },
    },
  },

  notificationCountBadge: {
    position: "absolute",
    top: "1px",
    right: "2px",
    backgroundColor: "#ffd200",
    color: "#101211",
    borderRadius: "50%",
    width: "18px",
    height: "18px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1400,
    border: `3px solid ${theme?.palette?.primaryBG?.[400]}`,
    fontSize: "10px",
    fontWeight: 700,
  },

  notificationItem: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    gap: "20px",
    padding: "16px 20px",
    borderBottom: `1px solid ${theme?.palette?.primaryBG?.[300] || "rgba(255, 255, 255, 0.1)"}`,
    cursor: "pointer",
    transition: "background-color 0.2s ease",

    "&:hover": {
      backgroundColor: theme?.palette?.primaryBG?.[300],
      "& $description": {
        color: theme?.palette?.primary2TextColor?.main,
      },
    },

    "&:last-child": {
      borderBottom: "none",
    },
  },

  iconContainer: {
    color: theme?.palette?.secondaryBG?.main,
  },

  textContainer: {
    flex: 1,
    minWidth: 0,
  },

  title: {
    color: theme?.palette?.primaryText?.[100],
    fontSize: "14px",
    fontWeight: 700,
    fontFamily: "Poppins, sans-serif",
    lineHeight: 1.2,
    marginBottom: "4px",
  },

  description: {
    color: theme?.palette?.primaryText?.[800],
    fontSize: "10px",
    fontWeight: 700,
    fontFamily: "Poppins, sans-serif",
    lineHeight: 1.4,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    wordBreak: "break-word",
    "& span": {
      color: theme?.palette?.secondaryBG?.main,
      fontWeight: 600,
    },
  },

  descriptionExpanded: {
    display: "block",
    WebkitLineClamp: "unset",
    WebkitBoxOrient: "unset",
    overflow: "visible",
    textOverflow: "unset",
    whiteSpace: "normal",
    wordBreak: "break-word",
  },

  showMoreText: {
    marginTop: "4px",
    color: theme?.palette?.secondaryBG?.main,
    fontSize: "10px",
    fontWeight: 700,
    fontFamily: "Poppins, sans-serif",
    cursor: "pointer",
    display: "inline-block",
  },
}));

export default useStyles;
